import React from 'react';
import cn from 'classnames';

import { Typography } from '../../shared/Typography';

import styles from './Toast.styles.scss';

const VARIANTS = {
  success: styles.success,
  warning: styles.warning,
  info: styles.info,
  error: styles.error,
};

const Toast = ({ className, variant, title, text }) => (
    <div className={cn(styles.toast, VARIANTS[variant], className)}>
      <div className={styles.inner}>
        <div className={styles.main}>
          <Typography className={styles.text} variant="body3">
            {text}
          </Typography>
        </div>
      </div>
    </div>
);

export default React.memo(Toast);
